export default class ReservierungPending {
  tischId: string
  zeitVon: string
  zeitBis: string
  kundeNachname: string
  kundeVorname: string
  kundeTelefon: string
  kundeEmail: string
  personen: number
}
